import { render, staticRenderFns } from "./LogsDialog.vue?vue&type=template&id=c51d7c26"
import script from "./LogsDialog.vue?vue&type=script&lang=js"
export * from "./LogsDialog.vue?vue&type=script&lang=js"
import style0 from "./LogsDialog.vue?vue&type=style&index=0&id=c51d7c26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports